import Ineos from './components/Ineos';

function Header() {
  return <Ineos />;
}

export default Header;
